import React from "react";
import CourseDetailPage from "../components/courses/CourseDetail";

const CourseDetail: React.FC = () => {
  return <CourseDetailPage />;
};

export default CourseDetail;
